import {
  approvalTemplate,
  approvalController,
  rejectTemplate,
  rejectController,
  remindTemplate,
  remindController,
  reviewController,
  reviewTemplate
} from "./modals"

import $ from "jquery";
import moment from "moment/moment";
import formatCurrency from "format-currency";


class ReviewController {

  constructor(AuthenticationService, CompanyService, toastr, $scope, $http, $rootScope, $state, $uibModal,  DTOptionsBuilder, $q, DTColumnBuilder, $compile,) {
    "ngInject";
    var self = this;
    this.authenticationService = AuthenticationService;
    this.name = 'review';
    this.$http = $http;
    this.state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.allSelected = false;
    this.filterText = "";
    this.$uibModal = $uibModal;
    this.submittedSheets = "";
    this.openSheets = "";
    this.rejectedSheets = "";
    this.awaitingRejection = "";
    this.actionsEnabled = false;
    this.statusFilter = 'all';
    this.toastr = toastr;
    this.additionalTimesheets = [];
    self.overduecount = 0;
    self.toapprovecount = 0;
    self.mistakecount = 0;
    self.rejectedcount = 0;

    self.$http.get(self.$rootScope.apiHost+'/api/review/timesheets/overduecount', {withCredentials: true}).then(function (success) {
      self.overduecount = success.data;
    });

    self.$http.get(self.$rootScope.apiHost+'/api/review/timesheets/rejectedcount', {withCredentials: true}).then(function (success) {
      self.rejectedcount = success.data;
    });

    self.$http.get(self.$rootScope.apiHost+'/api/review/timesheets/mistakecount', {withCredentials: true}).then(function (success) {
      self.mistakecount = success.data;
    });

    self.$http.get(self.$rootScope.apiHost+'/api/review/timesheets/toapprovecount', {withCredentials: true}).then(function (success) {
      self.toapprovecount = success.data;
    });


    self.$http.get(self.$rootScope.apiHost+'/api/admin/users/names?active=true', {withCredentials: true}).then(function (success) {
      self.activeUsers = success.data;
    });

    // this.$http.get($rootScope.apiHost+"/api/review/timesheets", {withCredentials: true}).then(function (success) {
    //   self.timesheets = success.data;
    //   self.timesheets.forEach((sheet) => sheet['selected'] = self.allSelected)
    //   self.filterTimesheets();
    //
    //
    //   self.loaded = true;
    // });

    this.timeSheetFilter = {
      status: 'ALL',
      employeeId: -1
    }

    this.timeSheetFilterRefresh = false;

    this.timeSheetFilterCriteria = function () {
      return "status="+self.timeSheetFilter.status+"&employeeId="+self.timeSheetFilter.employeeId;
    }


    this.timeSheetColumns = [
      {
        displayName: 'Employee',
        value: 'userFullName',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return record.userFullName;
        },
        clickFunction: function (record) {
          self.reviewTimesheet(record);
        }
      },
      {
        displayName: 'Start Date',
        value: 'startDate',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          return moment(record.startDate).format("MMM, DD, YYYY")
        }
      },
      {
        displayName: 'End Date',
        value: 'endDate',
        sortable: true,
        formatting: function (record) {
          return moment(record.endDate).format("MMM, DD, YYYY")
        }
      },
      {
        displayName: 'Status',
        value: 'status',
        sortable: true,
      },
      {
        displayName: 'Billable Hours',
        value: 'billableHoursWorked',
        sortable: false,
      },
      {
        displayName: 'Non Billable Hours',
        value: 'nonBillableHoursWorked',
        sortable: false,
      },
      {
        displayName: 'Hours for Timesheet Period',
        value: 'hoursForTimesheet',
        sortable: false,
      }
    ];


  }




  // reviewTimesheet(timesheet){
  //   let timesheetId = timesheet.id;
  //   this.state.go('reviewTimesheetDetail', {timesheetId});
  // }

  filterTimesheetsByUser(item) {
    this.timeSheetFilter.employeeId = item.id;
    this.timeSheetFilterRefresh = true;
    this.userSelected = true;
  }


  getSubmittedSheets(){
    if(this.timesheets) {
      return this.timesheets.filter(data => data.status.indexOf("SUBMITTED") != -1).length;
    }
  }

  getOpenSheets(){
    if(this.timesheets) {
      return this.timesheets.filter(data => data.status.indexOf("OPEN") != -1).length;
    }
  }

  getRejectedSheets(){
    if(this.timesheets) {
      return this.timesheets.filter(data => data.status.indexOf("REJECTED") != -1).length;
    }
  }

  getAwaitingRejection() {
    if(this.timesheets) {
      return this.timesheets.filter(data => data.status.indexOf("REJECTION_REQUESTED") != -1).length;
    }
  }

  canApprove(timesheet) {
    return timesheet.status !== 'SUBMITTED' && timesheet.status !== 'APPROVED';
  }

  canApproveBulk() {
    if(!this.actionsEnabled) {
      return true;
    }

    let disabled = false;
    this.filteredTimesheets.forEach((ts) => {
      if(ts.selected) {
        let notApprovable = this.canApprove(ts);
        if(!disabled && notApprovable) {
          disabled = true;
        }
      }
    });

    return disabled;
  }

  canRejectBulk() {
    if(!this.actionsEnabled) {
      return true;
    }

    let disabled = false;
    this.filteredTimesheets.forEach((ts) => {
      if(ts.selected) {
        let notRejectable = this.canReject(ts);
        if(!disabled && notRejectable) {
          disabled = true;
        }
      }
    });

    return disabled;
  }

  canRemindBulk() {
    if(!this.actionsEnabled) {
      return true;
    }

    let disabled = false;
    this.filteredTimesheets.forEach((ts) => {
      if(ts.selected) {
        let notRemindable = this.canRemind(ts);
        if(!disabled && notRemindable) {
          disabled = true;
        }
      }
    });

    return disabled;
  }

  canReject(timesheet) {
    return timesheet.status === 'REJECTED' || timesheet.status === 'OPEN';
  }

  canRemind(timesheet) {
    return timesheet.status === 'SUBMITTED' || timesheet.status === 'REJECTION_REQUESTED' || timesheet.status === 'APPROVED';
  }

  onRowCheckChange(){
    this.actionsEnabled = this.getSelectedTimesheets().length > 0;
  }

  onSelectAll() {
    this.allSelected = !this.allSelected;

    this.filteredTimesheets.forEach((ts) => {
      if(this.allSelected) {
        ts.selected = true;
      } else {
        ts.selected = false;
      }
    });

    this.actionsEnabled = this.allSelected;
  }


  filterTimesheets() {
    this.timeSheetFilterRefresh = true;
  }

  drillDown(status) {
    this.clearUser();
    this.timeSheetFilter.status = status;
    this.timeSheetFilter.employeeId = -1;
    this.filterTimesheets();
  }

  filterTimesheetsForUser($item) {
    this.userFilter = $item.id;
    this.userSelected = true;
    this.filterTimesheets();
  }

  clearUser() {
    this.userSelected = false;
    this.timeSheetFilter.employeeId = -1;
    this.selectedUser = undefined;
    this.filterTimesheets();
  }

  getSelectedTimesheets(){
    if(this.timesheets){
      return this.filteredTimesheets.filter(timesheet => timesheet.selected);
    }
    return [];
  }


  reviewTimesheet(timesheet) {
    let self = this;
    var modalInstance = this.$uibModal.open({
      template: reviewTemplate,
      controller: reviewController,
      controllerAs: "$ctrl",
      resolve: {
        timesheet: function(){
          return [timesheet];
        },
        additionalTimesheets: function () {
          return self.additionalTimesheets;
        }
      },
      windowClass: "app-modal-window"
    });

    // modalInstance.success = function () {
    //   self.$http.get(self.$rootScope.apiHost+"/api/review/timesheets", {withCredentials: true}).then(function (success) {
    //     self.timesheets = success.data;
    //     self.toastr.success("Timesheet successfully approved.", "Success!");
    //   });
    // }


  }



  approveTimesheet(timesheet) {
    let self = this;
    var modalInstance = this.$uibModal.open({
      template: approvalTemplate,
      controller: approvalController,
      controllerAs: "$ctrl",
      resolve: {
        items: function(){
          return [timesheet];
        }
      },
      windowClass: "hmodal-success"
    });

    modalInstance.success = function () {
      self.$http.get(self.$rootScope.apiHost+"/api/review/timesheets", {withCredentials: true}).then(function (success) {
        self.timesheets = success.data;
        self.toastr.success("Timesheet successfully approved.", "Success!");
      });
    }
  }

  approveTimesheets(){
    let self = this;
    var modalInstance = this.$uibModal.open({
      template: approvalTemplate,
      controller: approvalController,
      controllerAs: "$ctrl",
      resolve: {
        items: function(){
          return self.getSelectedTimesheets();
        }
      },
      windowClass: "hmodal-success"
    });

    modalInstance.success = function () {
      self.$http.get(self.$rootScope.apiHost+"/api/review/timesheets", {withCredentials: true}).then(function (success) {
        self.timesheets = success.data;
        self.toastr.success("Timesheets successfully approved.", "Success!");
      });
    }

  }



  rejectTimesheet(timesheet){
    let self = this;
    var modalInstance = this.$uibModal.open({
      template: rejectTemplate,
      controller: rejectController,
      controllerAs: "$ctrl",
      resolve: {
        items: function(){
          return [timesheet];
        }
      },
      windowClass: "hmodal-danger"
    });

    modalInstance.success = function () {
      self.$http.get(self.$rootScope.apiHost+"/api/review/timesheets", {withCredentials: true}).then(function (success) {
        self.timesheets = success.data;
        self.toastr.success("Timesheet successfully rejected.", "Success!");
      });
    }
  }

  rejectTimesheets(){
    let self = this;
    var modalInstance = this.$uibModal.open({
      template: rejectTemplate,
      controller: rejectController,
      controllerAs: "$ctrl",
      resolve: {
        items: function(){
          return self.getSelectedTimesheets();
        }
      },
      windowClass: "hmodal-danger"
    });

    modalInstance.success = function () {
      self.$http.get(self.$rootScope.apiHost+"/api/review/timesheets", {withCredentials: true}).then(function (success) {
        self.timesheets = success.data;
        self.toastr.success("Timesheets successfully rejected.", "Success!");
      });
    }
  }

  remindTimesheet(timesheet){
    let self = this;
    var modalInstance = this.$uibModal.open({
      template: remindTemplate,
      controller: remindController,
      controllerAs: "$ctrl",
      resolve: {
        items: function(){
          return [timesheet];
        }
      },
      windowClass: "hmodal-warning"
    });

    modalInstance.success = function () {
      self.$http.get(self.$rootScope.apiHost+"/api/review/timesheets", {withCredentials: true}).then(function (success) {
        self.timesheets = success.data;
        self.toastr.success("Reminder successfully sent.", "Success!");
      });
    }
  }

  remindTimesheets(){
    let self = this;
    var modalInstance = this.$uibModal.open({
      template: remindTemplate,
      controller: remindController,
      controllerAs: "$ctrl",
      resolve: {
        items: function(){
          return self.getSelectedTimesheets();
        }
      },
      windowClass: "hmodal-warning"
    });

    modalInstance.success = function () {
      self.$http.get(self.$rootScope.apiHost+"/api/review/timesheets", {withCredentials: true}).then(function (success) {
        self.timesheets = success.data;
        self.toastr.success("Reminders successfully sent.", "Success!");
      });
    }

  }
}

export default ReviewController;



// WEBPACK FOOTER //
// ./client/pages/review/review.controller.js